import {useContext, createContext} from 'react'
import {ProductDataType} from '@/types/product'

interface ProductContextDataType {
    product: ProductDataType
    productImageSrc: string
    isAddToCart: boolean
    addedToCartPodId: string
    registeredCustomerId?: string
    activeProduct: ProductDataType | null
    setVariantProductId: (productId: string) => void
    quickviewModalOpen: boolean | null
    setQuickviewModalOpen: React.Dispatch<React.SetStateAction<boolean>>
    itemQuantity: number
    setItemQuantity: React.Dispatch<React.SetStateAction<number>>
    bundledProducts?: ProductDataType[] | null
    bundleProductLoading?: boolean
    bundleProductError?: unknown
    setProductIdToFetch?: React.Dispatch<React.SetStateAction<string>>
}

type ProductContextType = ProductContextDataType | Record<string, never>

export const ProductContext = createContext<ProductContextType | Record<string, never>>({})

export const useProductContext = () => {
    const context = useContext(ProductContext)
    if (!context) {
        throw new Error(
            'useProductContext must be used within an ProductProvider. Please ensure all product-related components have access to the Product Context'
        )
    }
    return context
}
